export default {
	"Rush.ItsLateOhTheEventIsOver": "來晚了哦，活動已結束",
	"Rush.HotRush": "火熱搶購中",
	"Rush.fromTheEnd": "距結束",
	"Rush.OnlyTheBeginningIsLeft": "距開始只剩",
	"Rush.sky": "天",
	"Rush.time": "時",
	"Rush.divide": "分",
	"Rush.second": "秒",
	"Rush.MarketingMarketplaceListingPageProductClick": "行銷商城清單頁_商品點擊",
	"Rush.AListOfStoreItems": "店鋪商品清單",
	"Rush.MarketingMarketplace": "行銷商城",
	"Rush.SnapItUpNow": "立即搶購",
	"Rush.RobbedOfTheLight": "被搶光啦~"
}